import { render } from "./Paraphrase.vue?vue&type=template&id=4b2e9e8e&scoped=true"
import script from "./Paraphrase.vue?vue&type=script&lang=js"
export * from "./Paraphrase.vue?vue&type=script&lang=js"

import "./Paraphrase.vue?vue&type=style&index=0&id=4b2e9e8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2e9e8e"]])

export default __exports__